module.exports = __webpack_public_path__ + "static/img/数字内容创意.0450c3a7.png";